$(function(){
   console.log("asgjhgsa");
   console.log($(".navbar-nav").find("li").html());
    $("#navbarNav").find("li").on("click", "a", function () {
      console.log("ia m here");
        $('.navbar-collapse.in').collapse('hide');
    });
})